import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EventsService {
    constructor() {}

    trigger = new BehaviorSubject<any>({ name: null, value: null });
}
